import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Modal from '../Modal';

const PhysicianPagesAdminPanel = ({ children, onClose = () => {} }) => {
  const { t } = useTranslation('components', { keyPrefix: 'PhysicianPagesAdminPanel' });

  return (
    <Modal
      showCloseButton
      onClickCloseButton={onClose}
      onClickOutside={onClose}
      isScrollable={false}
      title={t('title')}
    >
      <div data-component="PhysicianPagesAdminPanel" className="max-h-full overflow-y-hidden flex">
        {children}
      </div>
    </Modal>
  );
};

PhysicianPagesAdminPanel.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default PhysicianPagesAdminPanel;
